import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SafeModule } from 'src/app/@core/pipes/pipe-modules/safe.module';
import { MaterialHeroBackgroundImageComponent } from './hero-background-image.component';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';





@NgModule({
  declarations: [
    MaterialHeroBackgroundImageComponent
  ],
  imports: [
    CommonModule,
    SafeModule.forRoot(),
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    FormsModule
  ],
  exports: [MaterialHeroBackgroundImageComponent]
})
export class MaterialHeroBackgroundImageModule { }